<!--suppress ALL -->
<template>
  <div>
    <!--资源管理左侧菜单-->
    <div id="zy_menu_left" class="col_2_1 w180 zy_menu_left" style="height:100%; overflow:hidden;">
      <span><a @click="editClassification('f', null, '', '0', '0')"  class="add2"></a></span>
      <dl class="main_menu" v-for="(item, idx) in RCTree" :key="item.id">
            <span>
              <dt class="total-scope">
                <a @click="searchByClassification(item.id)" class="single_ellipsis total-scope-name" style="width: 155px" :title="item.name">
                  <a v-if="sort_trigger !== idx" style="cursor: pointer;" title="点击排序" @click.stop="sort_trigger = idx">{{item.sort}} - </a>
                  <span v-if="sort_trigger == idx" >
                    <input type="text" v-model="item.sort" style="width: 20px;">
                    <span style="cursor: pointer; border-radius: 2px; padding: 2px; box-sizing: border-box; background: #ff3633; color: white; font-size: 10px;" @click.stop="classification = item; submitClassification(item.name, item.sort); sort_trigger = null;">保存</span>
                  </span>
                  {{item.name}}
                </a>
                <a href="javascript:void(0);" @click="editClassification('s', null, '', item.id, '0')" class="addSub" title="添加子类"></a>
                <i class="edit" title="编辑" @click="editClassification('f', item.name, item.id, item.parentId, item.parent_ids, item.sort)"></i>
                <a href="javascript:;" title="删除" @click="delRC(item.id)"><i class="del main_menu_del"></i></a><i class="up_icon icon_c"></i>
              </dt>
              <!--此处字数请程序控制不超过7个汉字-->
              <ul class="ul1 total-scope-tan subUL">
                <!--dd v-for="n in item.nodes" :key="n.id" v-dragging="{ item: n, list: item.nodes, sortType: 'name_s_sort' }"-->
                <dd v-for="(n, idx) in item.nodes" :key="n.id">
                  <a @click="searchByClassification(n.id)" class="single_ellipsis subTitle" style="width: 135px" >
                    <a v-if="sort_trigger1 !== idx" style="cursor: pointer;" title="点击排序" @click.stop="sort_trigger1 = idx">{{n.sort}} - </a>
                    <span v-if="sort_trigger1 == idx" >
                      <input type="text" v-model="n.sort" style="width: 20px;">
                      <span style="cursor: pointer; border-radius: 2px; padding: 2px; box-sizing: border-box; background: #ff3633; color: white; font-size: 10px;" @click.stop="classification = n; submitClassification(n.name, n.sort); sort_trigger1 = null;">保存</span>
                    </span>
                    {{n.name}}
                  </a> <i class="edit" title="编辑" @click="editClassification('s', n.name, n.id, n.parentId, n.parent_ids, n.sort)"></i>
                  <a href="javascript:;" title="删除" @click="delRC(n.id)"><i class="del delSub"></i></a>
                </dd>
                <P>
                </P>
              </ul>
            </span>
      </dl>
    </div>
    <!--/资源管理左侧菜单-->
    <!--资源管理右侧列表-->
    <div class="col_2_2 w797 zy_right">
      <div class="zy_right_title">知识库管理</div>
      <div class="gj_top_class">
        <input name="" type="button" class="btn_s_gj" @click="searchByFilter()" /><input name="title" type="text" class="put_gj" v-model="filter.allContent" @keyup.13="searchByFilter()"/>
        <select name="isPublic" class="selcet_put" v-model="filter.isOpen" @change="searchByFilter()">
          <option value="">是否公开</option>
          <option value="0">公开</option>
          <option value="1">不公开</option>
        </select>
        <a class="btn btn_add" @click="editResource('')">新增文章</a>
      </div>
      <div class="zy_list" style="min-height:670px;">
        <dl v-for="item in list" :key="item.id">
          <dt>
            <div @click="editResource(item.id)">
              <a href="javascript:void(0);">
                <img v-if="item.cover" :src="item.cover"/>
                <img v-if="!item.cover" src="@/assets/images/zy_list_3@2x.png"/>
              </a>
            </div>
          </dt>
          <dd>
            <p>{{item.title}}</p>
            <p class="update">{{item.updateDate}}</p>
          </dd>
        </dl>
        <h5 class="none_ts" v-if="resourceCnt <= 0">
          <img src="@/assets/images/none_data.jpg" alt="">
        </h5>
      </div>
      <div class="zy_list_bottom">
        <dl>
          <dt><!--<input id="sel_1" type="checkbox" v-model="allCheck" style="opacity: 1;" /> 全选 <input name="" type="button" value="批量上架" class="btn_zy_bottom" /> <input name="" type="button" value="批量下架"  class="btn_zy_bottom"/>--> <!--<input name="" type="button" value="删除所选"  class="btn_zy_bottom" />--> 共{{resourceCnt}}篇文章</dt>
          <dd v-if="resourceCnt > 0">
            <paginate :click-handler="clickCallback" :page-count=pages
                      :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                      :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                      :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                      :first-last-button=$global.paginationOptions.first_last_button
                      :active-class=$global.paginationOptions.active_class
                      :disabled-class=$global.paginationOptions.disabled_class
                      :first-button-text=$global.paginationOptions.first_button_text
                      :last-button-text=$global.paginationOptions.last_button_text
                      :prev-text=$global.paginationOptions.prev_text
                      :next-text=$global.paginationOptions.next_text>
            </paginate>
          </dd>
        </dl>
      </div>
    </div>
    <!--/资源管理右侧列表-->

    <!--添加大类弹出-->
    <div class="tan add_b_menu" style="display:none;">
      <div class="add_con">
        <dl>
          <dt style="height: 45px;">
            <input name="" type="text" v-model="name_f" placeholder="请输入大类名称"/>
          </dt>
          <dt style="height: 95px;">
            <input name="" type="text" v-model="name_f_sort" placeholder="请输入排序"/>
          </dt>
          <dd>
            <input name="" type="button" value="取消" @click="$utils.fadeOut('.add_b_menu')" />　　
            <input type="button" value="确定" class="red_color" @click="submitClassification(name_f, name_f_sort)" /></dd>
        </dl>
      </div>
    </div>
    <!--/添加大类弹出-->
    <!--添加子类弹出-->
    <div class="tan add_s_menu" style="display:none;">
      <div class="add_con">
        <dl>
          <dt style="height: 45px;">
            <input type="text" v-model="name_s" placeholder="请输入子类名称"/>
          </dt>
          <dt style="height: 95px;">
            <input type="text" v-model="name_s_sort" placeholder="请输入排序"/>
          </dt>
          <dd>
            <input type="button" value="取消" @click="$utils.fadeOut('.add_s_menu')" />　　
            <input type="button" value="确定" class="red_color" @click="submitClassification(name_s, name_s_sort)" />
          </dd>
        </dl>
      </div>
    </div>
    <!--/添加子类弹出-->
    <!--停用弹出-->
    <div class="tan stop_btn" style="display:none;">
      <div class="add_con">
        <dl>
          <dt>您确定下架该资源吗？</dt>
          <dd><input name="" type="button" value="取消" @click="$utils.fadeOut('.stop_btn')" />　　<input name="" type="button" value="确定" class="red_color" @click="submitPutOnOff('4', putOnOffArr)" /></dd>
        </dl>
      </div>
    </div>
    <!--/停用弹出-->
    <!--启用弹出-->
    <div class="tan open_btn" style="display:none;">
      <div class="add_con">
        <dl>
          <dt>您确定需要启用吗？</dt>
          <dd><input name="" type="button" value="取消" @click="$utils.fadeOut('.open_btn')" />　　<input name="" type="button" value="确定" class="red_color" @click="submitPutOnOff('5', putOnOffArr)" /></dd>
        </dl>
      </div>
    </div>
    <!--/启用弹出-->
    <!--资源预览弹出-->
    <div class="tan resourcePreview" style="display:none;">
      <div class="px_add_con rp_add_con" style="height:520px;">
        <div class="h370 rdiv" style="height:550px;">
          <h3>资源预览</h3>
          <a  href="javascript:void(0);"  class="close" @click="closeViewModal()" ></a>
          <div class="h200" style="overflow-x:hidden;height:480px;">
            <div  class="video_con" style="padding-top:10px;height:420px;">
              <!--视频-->
              <video-player  class="video-player-box"
                             ref="videoPlayer"
                             :options="playerOptions"
                             :playsinline="true"
                             customEventName="customstatechangedeventname">
              </video-player>
              <!--/视频-->
              <!--<div class="video_bottom">
                <dl>
                  <dt>
                    <p>共{{(resourceInfo.length/60).toFixed(2)}}分钟</p>
                  </dt>
                  <dd>
                    <p>上传时间：{{resourceInfo.createTime}} &#45;&#45; 上传者：{{resourceInfo.createName}}</p>
                    &lt;!&ndash;<p>文件大小：400M</p>&ndash;&gt;
                  </dd>
                </dl>
              </div>-->
            </div>
          </div>
        </div>
        <div class="clear"></div>
        <!--<div class="w240 wrap" style="text-align: center">
          <input name="" type="button" value="确定" class="all_btn" @click="closeViewModal()" />
        </div>-->
      </div>
    </div>
    <!--/资源预览弹出-->
  </div>
</template>
<script>

  import Dropdown from '@/store/modules/dropdowns'
  import {init} from '@/assets/js/public'
  import Paginate from 'vuejs-paginate'
  import router from '@/router'
  import Bus from '@/utils/bus'
  import { mapState, mapActions } from 'vuex'
  // require styles
  import 'video.js/dist/video-js.css'
  import { videoPlayer } from 'vue-video-player'
  import utils from '@/utils'
  export default {
    components: { Paginate, videoPlayer },
    data () {
      return {
        Dropdown: Dropdown,
        filter: {
          pageNo: 1,
          pageSize: 15,
          isOpen: "",
          allContent: ''
        },
        list: [],
        RCTree: [],
        allCheck: '',
        pages: 0,
        resourceCnt: 0,

        name_f: '',
        name_s: '',
        name_f_sort: '0',
        name_s_sort: '0',
        sort_trigger: null,
        sort_trigger1: null,
        dragged_item: {},

        classification: {},
        resourceInfo: {},
        putOnOffArr: [],
        prefix: this.$route.meta.prefix || '',
        playerOptions: {
          // videojs options
          muted: true,
          width: 640,
          height: 400,
          language: 'en',
          playbackRates: [1.0],
          sources: [{
            type: "video/mp4",
            src: "http://vod.bylonline.cn/9fc0cb5a737f4e08b93b3d360340dfff/a09f29b95fbd4249b74e7073dbf537e6-734884e784050aa4f71eae0abec3e9cb-ld.mp4"
          }],
          poster: ""
        }
      }
    },
    created () {
      this.getResourceClassification()
      this.getResources(this.filter)
    },
    mounted () {
      this.$nextTick(() => {
        init()
      })
      Bus.$on('initData_/org/resourceList', (data) => { // 点击菜单“资源管理”重置数据
        this.filter =  {
          pageNo: 1,
          pageSize: 15,
          allContent: "",
          isOpen: ""
        }
        this.getResources(this.filter)
      })
   /*   this.$dragging.$on('dragged', ({ value }) => {
        this.dragged_item = value.list
      })
      this.$dragging.$on('dragend', () => {
        this.dragged_item.forEach((o, idx) => {
          o.parent_ids = '0'
          o.sort = idx
        })
        this.$api.post(this.$global.bylApiPath, '/knowledgeClassification/batchEdit', {knowledgeClassificationList: this.dragged_item}, r => {
          this.getResourceClassification()
        })
      })*/
    },
    computed: {
      player () {
        return this.$refs.videoPlayer.player
      }
    },
    methods: {
      clickCallback (pageNum) {
        this.filter.pageNo = pageNum
        this.getResources(this.filter)
      },
      // 编辑大分类
      editClassification (type, name, id, parentId, parentIds, sort) {
        if (type == 'f' && name == null) {
          this.$utils.fadeIn('.add_b_menu')
          this.name_f = ''
          this.name_f_sort = ''
        } else if (type == 's' && name == null) {
          this.$utils.fadeIn('.add_s_menu')
          this.name_s = ''
          parentIds = parentIds + ','+parentId
          this.name_s_sort = ''
        } else if (type == 'f' && name != null) {
          this.$utils.fadeIn('.add_b_menu')
          this.name_f = name
          this.name_f_sort = sort
        } else if (type == 's' && name != null) {
          this.$utils.fadeIn('.add_s_menu')
          this.name_s = name
          this.name_s_sort = sort
        }
        this.classification = {
          id: id,
          name: name,
          parentId: parentId || '0',
          parent_ids: parentIds || '0',
          sort: sort
        }
      },
      submitClassification (name, sort) {
        if (!this.classification.parent_ids) { this.classification.parent_ids = '0' }
        if (name && name != '') {
          this.classification.name = name
          this.classification.sort = sort
          this.$api.post(this.$global.bylApiPath, '/knowledgeClassification/edit', this.classification, r => {
            this.$utils.fadeOut('.add_b_menu')
            this.$utils.fadeOut('.add_s_menu')
            this.classification = {}
            this.getResourceClassification()
          })
        }
      },
      searchByClassification (id) {
        this.filter = {
          pageNo: 1,
          pageSize: 15,
          classificationId: id,
          type: "",
          isOpen: ""
        }
        this.getResources(this.filter)
      },
      searchByFilter () {
        this.filter.pageNo = 1
        this.getResources(this.filter)
      },
      getResources (filter) {
        this.$api.post(this.$global.bylApiPath, '/knowledgeInfo/findList', filter, r => {
          this.resourceCnt = r.cntData
          this.pages = Math.ceil(r.cntData / this.filter.pageSize)
          this.list = r.data
        })
      },
      editResource (id) {
        if (id == '') {
          id = 'create'
        }
        this.$router.push({path: this.prefix + '/org/repo/'+ id})
      },
      delRC (id) {
        this.$api.get(this.$global.bylApiPath, '/knowledgeClassification/delete', {id: id}, r => {
          this.getResourceClassification()
        })
      },
      getResourceClassification () {
        this.$api.get(this.$global.bylApiPath, '/knowledgeClassification/findList', {}, r => {
          let tree = r
          this.RCTree = tree.data
        })
      },
      putOnOff (type, id, e) {
        e.stopPropagation();
        this.putOnOffArr = []
        var action
        if (type == 'on') {
          action = '5'
          this.$utils.fadeIn('.open_btn')
        } else if (type == 'off') {
          action = '4'
          this.$utils.fadeIn('.stop_btn')
        }
        this.putOnOffArr.push(id)
      },
      submitPutOnOff (action, idArr) {
        var idStr = ''
        for (var i = 0; i<idArr.length; i++) {
          if (i < idArr.length -1) {
            idStr += idArr[i] + ','
          } else if (i == idArr.length -1) {
            idStr += idArr[i]
          }
        }
        this.$api.get(this.$global.resourceApiPath, '/resource/action/batch', {action: action, ids: idStr}, r => {
          if (action == '4') {
            this.$utils.fadeOut('.stop_btn')
          } else if (action == '5') {
            this.$utils.fadeOut('.open_btn')
          }
          this.getResources(this.filter)
        })
      },
      viewResource (id, type, e) {
        e.stopPropagation();
        this.$api.get(this.$global.resourceApiPath, '/resource/view/' + id, {}, r => {
          this.resourceInfo = r.data
          if (type=='2') {
            this.$refs.videoPlayer.player.src(this.resourceInfo.filePathMp4)
            this.$utils.fadeIn('.resourcePreview')
          } else {
            window.open(this.resourceInfo.filePathMp4, '_black')
          }
        })
      },

      closeViewModal () {
        this.$utils.fadeOut('.resourcePreview')
        this.$refs.videoPlayer.player.pause()
      }
    }
  }
</script>
<style lang="scss">
  .total-scope-tan { background: black; }
</style>



// WEBPACK FOOTER //
// src/page/byl/org/repo/list.vue